import { initFacebookSdk } from "./facebook"; 

const initializeSDKs = () => {
    // facebook
    initFacebookSdk();
}

export default initializeSDKs;